// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zr4W","footer":"styles_footer__1LE54"};